import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  CLEAR_LOGIN_ERROR,
  RESET_LOGOUT_STATE,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  isLoggedOut: false, // Track logout state
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
        error: "",
        isLoggedOut: false, // Reset logout state when login starts
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        isLoggedOut: false, // Reset logout state on successful login
      }
      break
    case LOGOUT_USER:
      state = { 
        ...state, 
        isLoggedOut: true, // Set logout state
      }
      break
    case LOGOUT_USER_SUCCESS:
      state = { 
        ...state, 
        isLoggedOut: true, // Maintain logout state
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case CLEAR_LOGIN_ERROR:
      state = { ...state, error: "" }
      break
    case RESET_LOGOUT_STATE:
      state = { ...state, isLoggedOut: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
